
import React,{useState} from 'react';
import { Password } from 'primereact/password';
import { Controller } from 'react-hook-form'; 
import { InputText } from 'primereact/inputtext'; 
import { FaEyeSlash } from 'react-icons/fa';
import eye from '../../assests/images/Eye.png'
import eyeSlash from '../../assests/images/Invisible.png';
import iconError from '../../assests/images/icon-err.png'

const CommonPasswordInput = ({ name, label, register, errors, validationFn,control,placeholder,disabled,inputStyle,errorStyle,resErrorFlag,handleRemoveData }) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };
    // console.log("case33",errors)
  return (
    <>
     <div className="p-field">
     {label && <label htmlFor={name} className={"mt-2 fw-bold"}>
        {label} <span className="required"> *</span>
      </label>}
      <div className="position-relative">
         <Controller
          name={name}
          control={control}
          disabled={disabled}
          render={({ field }) => (
            <InputText
              {...field}  
              type={showPassword ? 'text' : 'password'}
              // || errorFlag
              className={errors?.[name] || resErrorFlag  ? 'p-invalid requiredError pw-asterik error-placeholder' : inputStyle  ?  'input-style-common mt-1 p-inputtext pw-asterik' : 'mt-1 p-inputtext pw-asterik'}
              placeholder={placeholder}
              style={{ paddingRight: '2rem' }}
            />
          )}
          rules={{
            validate: (value) => {
              const { errorFlag, error } = validationFn({ FieldName: name, value });
              if (errorFlag) {
                return error;
              }
              return true;
            }
          }}
        />
        {!resErrorFlag ? 
         <span
         className={"password-toggle-icon icon-password"}
         onClick={togglePasswordVisibility}
         style={{ position: 'absolute', right:'2rem', top: '55%', transform: 'translateY(-50%)', cursor: 'pointer' }}
       >
         {showPassword ? <img src={eye} />: <img src={eyeSlash} /> }
       </span>
       :
       <span
         className={"password-toggle-icon icon-password"}
         style={{ position: 'absolute', right:'2rem', top: '55%', transform: 'translateY(-50%)', cursor: 'pointer' }}
       >
      <img src={iconError} onClick={handleRemoveData} />  
       </span>
      
         } 
       
        </div>
        {errors?.[name] && <small className="p-error">{errorStyle ==true && errors[name].message }</small>}

      </div>
      </>
  );
};

export default CommonPasswordInput;
      